import { gql } from "apollo-boost"

export const getGeneralInfo = gql`
  query GeneralInformation($id: ID!) {
    GeneralInformation(id: $id) {
      id
      name
      type
      assignedTechnicalMonitor
      assignedFinancialMonitor
      applyingCall
      township
      region
      allies
      closureDescription
      alliedOne
      alliedTwo
      BlockingProjectDetails
      BlockingImplementationLocations
      BlockingConsultants
      BlockingDocuments
      BlockingDevelopmentObjective
      implementationPlace
      responsible
      startDate
      endDate
      strategicAxis
      priorityactions
      preventionLevel
      scope
      issueDescription
      description
      justification
      developmentObjective
      generalObjective
      communicationObjective
      state
      status
      statusChangedAt
      deadline
      signedContractAt
      agreementNumber
      technicalOpinion
      budgeted
      approved
      evidenced
      difference
      createdAt
      implementer {
        id
        email
        rfc
        type
        name
        email
        phone
        vision
        history
        mission
        director
        alliances
        socialObject
        fiscalAddress
        commercialName
        previousSupports
        commercialAddress
        incomesAndExpenses
        legalRepresentative
        institutionalExperience
        proofOfCharitableContributions
        councilMembers {
          charge
          name
        }
      }
      consultants {
        id
        isBlocking
        description
        commercialName
        commercialAddress
        contactName
        phone
        rfc
        fiscalAddress
        fiscalPersonType
        identifiedConsultant
        budgetConcept{
          id
          name
          unitCost
          totalUnits
        }
        assignedActivities{
          title
          id
        }
        hadReceivedSupports
        supports {
          id
          name
          receivedAt
          amount
        }
        documents {
          id
          name
          url
          type
        }
      }
      specificObjectives {
        id
        description
        orderIndex
      }
      beneficiaries {
        id
        isBlocking
        name
        description
        number
        gender
        educationLevel
        beneficiaryIndex
        age
        preventionLevel
        specificObjectives {
            id
            description
            orderIndex
        }
      }
      documents {
        id
        name
        url
        type
      }
      closureDocuments {
        id
        url
        name
        type
      }
      schedulePlace{
        id
        place
        linkplace
        placeUrl
        zipcode
        subdivision
        number
        street
        city
      }
    }
  }
`


export const getGeneralInfoRH = gql`
  query GeneralInformationRH($id: ID!) {
    GeneralInformationRH(id: $id) {
      id
      status
      BlockingConsultants
      startDate
      endDate
      consultants {
        id
        isBlocking
        description
        commercialName
        commercialAddress
        contactName
        phone
        rfc
        fiscalAddress
        fiscalPersonType
        identifiedConsultant
        hadReceivedSupports
        requestDate 
        startDate 
        terminationDate 
        implementer 
        project 
        status
        adminComment
        historyId
        submissionId
        outgoing_name 
        outgoing_email
        outgoing_phone
        outgoing_commercialName 
        outgoing_commercialAddress
        outgoing_contactName 
        outgoing_rfc 
        outgoing_fiscalAddress
        outgoing_placeOfImplementation
        outgoing_regimenFiscal
        placeOfImplementation 
        reasonForLeaving
        leavingDate
        regimenFiscal 
        benefits 
        publicCall 
        justification 
        relationship 
        relationshipDetail 
        publicAdministration 
        termsAcceptances 
        position_administration 
        contractType_administration 
        hours_administration 
        consultantAssignments {
          conceptId
          monthlyDistribution
          monthlyDistributionHours
          activities {
            activityId
            monthlyDistribution
          }
        }
        budgetConcept{
          id
          name
          unitCost
          totalUnits
        }
        assignedActivities{
          title
          id
        }
        supports {
          id
          name
          receivedAt
          amount
        }
        documents {
          id
          name
          url
          type
        }
        comments {
          id
          fieldName
          userRol
          User
          reviewed
          revision
          comment
          type
          parentCommentId
        }
      }
    }
  }
`
